<template>
  <div>
    <el-table :data="merchants">
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="商家用户ID"> </el-table-column>
      <el-table-column prop="freezeAmount" label="冻结金额"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="danger"
            @click="remove(scope.row.userId)"
            size="mini"
            v-if="scope.row.status === 1"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'merchantList',
  computed: {
    ...mapState('merchant', ['totalCount', 'pagination', 'merchants'])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions('merchant', ['removeMerchant']),
    remove(id) {
      this.$confirm('确定移除商户', '提示', {
        type: 'warning'
      }).then(() => {
        this.removeMerchant({ userId: id }).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功！'
          });
          this.$emit('refresh');
        });
      });
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    }
  }
};
</script>

<style lang="less" scoped></style>
